import * as React from "react";
import { SVGProps } from "react";

const ApolloCurrency = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 36" {...props}>
    <path
      fill="#e5b349"
      d="M16.2 8.4 19 13 5.2 36.4H0zM21.4 0h-6.1l19.3 31.7h-5.3l-8.6-14.8L9.5 35.8h5.8l5.4-10.1 5.9 10.1h15.1z"
    />
  </svg>
);

export default ApolloCurrency;
